import { Customer } from '../../../../selectors/select-customer/types';
import { CustomerActionType } from '../../../../actions/customer';
import { PricingDrawerActions } from '../../../../components/pricing-drawer/types';
import { RefinePriceSchemas } from './types';
import { RefinePriceSchemaType } from '../../form/schema';
import getUpdatedFields from '../../../../components/pricing-drawer/utils/get-updated-fields';
import submitUpdatedRefineFields from '../../../../utils/submit-updated-refine-fields';

type Params = {
  // TODO: [AP-1626] this is probably wrong, it can be either CustomerActionType or (CustomerActionType &PricingDrawerActions). It's also eerily duplicated in src/client/utils/submit-updated-refine-fields/index.ts
  actions: CustomerActionType | PricingDrawerActions;
  formValues: RefinePriceSchemas;
  initialValues: RefinePriceSchemas;
  customer: Customer;
};

const submitRefinePrice = ({ actions, formValues, initialValues, customer }: Params) => {
  const { scale, rebate } = customer;
  // remove lead properties from form values before getting updated fields
  const { email, name, phone, ...pricingFormValues } = formValues as RefinePriceSchemaType;
  const updatedFields = getUpdatedFields({ formValues: pricingFormValues, initialValues, scale });

  submitUpdatedRefineFields({ actions, rebate, scale, updatedFields });
  actions.customer.changeHasRefinedPrice(true);
  if ('drawer' in actions) {
    actions.drawer.closeDrawer();
  }
};

export default submitRefinePrice;
